module.exports = __webpack_public_path__ + "static/img/边6.e329ff4.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/decorativePainting/imgs/边6.png
// module id = vS7U
// module chunks = 2